import { render } from "./NotificationsTitle.vue?vue&type=template&id=6f5c2d43"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6f5c2d43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f5c2d43', script)) {
    api.reload('6f5c2d43', script)
  }
  
  module.hot.accept("./NotificationsTitle.vue?vue&type=template&id=6f5c2d43", () => {
    api.rerender('6f5c2d43', render)
  })

}

script.__file = "src/views/settings/pageTitles/NotificationsTitle.vue"

export default script